export const VIEW_RECEIPT = 'viewReceipt';
export const REORDER = 'reorderBtn';
export const REVIEW_ORDER = 'reviewOrder';
export const WELCOME_TEXT = 'welcome';
export const CAROUSAL_CONFIG = {
  SPEED: 200,
  SLIDES_TO_SHOW: 3,
  SLIDES_TO_SCROLL: 1,
  BREAKPOINT: 1024,
  SLIDES_TO_SCROLL_MOBILE: 1,
  FADE_CARD_INDEX: 3,
  SILCK_RESPONSIVE_PROPERTY: [
    {
      breakpoint: 1950,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1720,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1252,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 880,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
      },
    },
  ],
};
export const CONTINUE = 'continue';
export const CANCEL = 'cancel';
